import {postData} from "../api/componentAPIs"
export function fetchConfig() {
  //Change the query string to avoid JSON caching
  return fetch("../externalConfig/config.json?release=1.3.3").then((response) =>
    response.json()
  );
}

export function SavePreferences({ name, config, userColumnPref, userId }) {
  if (!userColumnPref) {
    userColumnPref = {};
  }
  userColumnPref[name] = config;
  postData("SetUserPreferences", {
    userId: userId,
    columnOrderPref: JSON.stringify(userColumnPref),
  }).then(
    (response) => {
      if (response && response.status === 200)
        console.log(`User ${userId} preferences saved`);
    },
    (error) => {
      console.log("Error while saving preferences ", error);
    }
  );
  return userColumnPref;
}

export const getDeserializedRouteNameConfig = (jsonString) => {
  const routeConfig = JSON.parse(jsonString);
  // Map the mask array, converting string patterns to RegExp objects
  // Keep "_" as a string, as it represents a single character wildcard, it will be prefilled in the UI when user types on the mask field
 
  return {
    ...routeConfig,
    mask: routeConfig.mask.map(mask => ["_","-"].includes(mask) ?  mask : new RegExp(mask)),
    format: new RegExp(routeConfig.format),
  }
}

export const getTerminalAccessLabel = (code) => {
  switch (code) {
    case 2:
      return {
        menuLabel: "Svc Center",
        moduleTitle: "Service Center Access",
        shortName:"Svc Center",
        fullName:"Service Center",
        suffix:"Svc"
      };
    case 1:
    default:
     return {
       menuLabel: "Terminal Access",
       moduleTitle: "Terminal Access",
       shortName: "Terminal",
       fullName: "Terminal",
       suffix:"Term"
     };
  }
}

export const getInternationalNumberFormat = (value) => {
  const numericValue = Number(value);
  return isNaN(numericValue) ? '0' : new Intl.NumberFormat('en-US').format(numericValue);
};

export const convertMilliSecondsToSeconds = (milliSeconds) => {
  return Math.round(milliSeconds / 1000);
}